import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openCollection = (collectionKey) => {
    window.dispatchEvent(
      new CustomEvent('openCollection', { detail: collectionKey })
    );
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Chahine Cutlery</h3>
            <p>
              Four generations of artisanal mastery, crafting timeless elegance 
              for discerning tables since 1924.
            </p>
          </div>

          <div className="footer-section">
            <h4>Collections</h4>
            <ul>
              <li><button onClick={() => openCollection('diningsets')}>Dining Sets</button></li>
              <li><button onClick={() => openCollection('servingsets')}>Serving Sets</button></li>
              <li><button onClick={() => openCollection('ornamentals')}>Ornamentals</button></li>
              <li><button onClick={() => openCollection('olivewood')}>Olive Wood</button></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li><button onClick={() => scrollToSection('heritage')}>Our Heritage</button></li>
              <li><button onClick={() => scrollToSection('featured')}>Featured</button></li>
              <li><button onClick={() => scrollToSection('contact')}>Contact</button></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            <div className="contact-info">
              <p>Chahine Cutlery<br />Jezzine, Lebanon</p>
              <p>Phone: 07 780 324<br />Email: info@chahinecutlery.com</p>
              <p>Mon-Sun: 10-6</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Chahine Cutlery. All rights reserved.</p>
            <p>Handcrafted with pride in Lebanon</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;